webpackJsonp([0],{

/***/ "/D0J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_impressum_vue__ = __webpack_require__("NNjJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85f322c0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_impressum_vue__ = __webpack_require__("NXbQ");
function injectStyle (ssrContext) {
  __webpack_require__("ln2+")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-85f322c0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_impressum_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_85f322c0_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_impressum_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "/m10":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/BHKWII.2e332db.jpg";

/***/ }),

/***/ "323/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/klaerwerk.9ca82eb.jpg";

/***/ }),

/***/ "3LPk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/tegelgrund.95369b1.jpg";

/***/ }),

/***/ "3NXS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "7Sn+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/hafen.040ef38.jpg";

/***/ }),

/***/ "7zck":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CDGV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/heinestrasse.41db7d8.jpg";

/***/ }),

/***/ "CJgd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Card__ = __webpack_require__("ZNfX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CardHeader__ = __webpack_require__("efVn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CardBody__ = __webpack_require__("XAfO");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        'Card': __WEBPACK_IMPORTED_MODULE_0__components_Card__["a" /* default */],
        'CardHeader': __WEBPACK_IMPORTED_MODULE_1__components_CardHeader__["a" /* default */],
        'CardBody': __WEBPACK_IMPORTED_MODULE_2__components_CardBody__["a" /* default */]
    }
});

/***/ }),

/***/ "FZY4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',{staticClass:"page-header"},[_vm._v("Auszug aus der Referenzliste")]),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm8":"","offset-sm2":""}},[_c('v-container',_vm._b({attrs:{"fluid":""}},'v-container',( _obj = {}, _obj[("grid-list-" + _vm.size)] = true, _obj ),false),[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.content),function(item){return _c('v-flex',{key:item.title,staticStyle:{"padding":"10px"},attrs:{"xs12":"","sm12":"","md6":"","lg4":""}},[_c('div',{staticClass:"z-depth-1",staticStyle:{"height":"100%"}},[_c('v-card',{staticStyle:{"height":"100%"}},[_c('v-card-media',{attrs:{"src":item.titlepicture,"height":"200px"}}),_vm._v(" "),_c('v-card-text',{staticClass:"mh-100",staticStyle:{"height":"100%"}},[_c('h4',{staticClass:"card-title"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"items":item.body,"hide-actions":"","hide-headers":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.head))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(props.item.text))])]}}])})],1)],1)],1)])}))],1)],1)],1)],1)
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "H7ld":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',[_c('v-flex',{staticStyle:{"padding":"10px","padding-top":"20px"},attrs:{"xs12":"","sm8":"","offset-sm2":""}},[_c('card',{staticClass:"z-depth-1"},[_c('v-card-media',{attrs:{"src":__webpack_require__("gDL6"),"height":"200px"}},[_c('v-layout',{staticStyle:{"width":"100%","height":"100%"},attrs:{"column":""}},[_c('v-spacer'),_vm._v(" "),_c('v-flex',[_c('div',{staticStyle:{"width":"100%","font-weight":"bold","text-align":"center"}},[_c('h1',{staticStyle:{"font-weight":"bold","font-size":"300%","color":"white","text-shadow":"0 0 5px black"}},[_vm._v("Planungsbüro für Energieanlagen")])])])],1)],1),_vm._v(" "),_c('card-body',[_c('v-layout',[_c('v-flex',{staticStyle:{"padding":"35px"},attrs:{"xs6":""}},[_c('div',{staticClass:"view zoom z-depth-2"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__("/m10"),"alt":"placeholder."}}),_vm._v(" "),_c('div',{staticClass:"mask flex-center",on:{"mouseover":function($event){_vm.hovered = true},"mouseleave":function($event){_vm.hovered = false}}},[(_vm.hovered)?_c('h4',{staticClass:"white-text"},[_vm._v("BHKW II - Airbus")]):_vm._e()])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h4',{staticClass:"card-title",staticStyle:{"text-align":"center","font-weight":"bold","color":"#112f6b"}},[_vm._v("Kraftwerkstechnik")]),_vm._v(" "),_c('v-list',_vm._l((_vm.content.kraftwerktechnik),function(item){return _c('v-list-tile',{key:item.text,attrs:{"avatar":""}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("keyboard_arrow_right")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-content',{staticStyle:{"text-overflow":"ellipsis"},domProps:{"textContent":_vm._s(item.text)}})],1)],1)}))],1)],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs6":""}},[_c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h4',{staticClass:"card-title",staticStyle:{"text-align":"center","font-weight":"bold","color":"#112f6b"}},[_vm._v("Gesamtplanung von BHKWs")]),_vm._v(" "),_c('v-list',_vm._l((_vm.content.bhkw),function(item){return _c('v-list-tile',{key:item.text,attrs:{"avatar":""}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("keyboard_arrow_right")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-content',{staticStyle:{"text-overflow":"ellipsis"},domProps:{"textContent":_vm._s(item.text)}})],1)],1)}))],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{staticStyle:{"padding":"35px"},attrs:{"xs6":""}},[_c('div',{staticClass:"text-center view zoom z-depth-2"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__("fV6z"),"alt":"placeholder."}}),_vm._v(" "),_c('div',{staticClass:"mask flex-center",on:{"mouseover":function($event){_vm.hovered2 = true},"mouseleave":function($event){_vm.hovered2 = false}}},[(_vm.hovered2)?_c('h4',{staticClass:"white-text"},[_vm._v("BHKW Klosterforst - Stadtwerke Itzehoe")]):_vm._e()])])])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-layout',[_c('v-flex',{staticStyle:{"padding":"35px"},attrs:{"xs6":""}},[_c('div',{staticClass:"text-center view zoom z-depth-2"},[_c('img',{staticClass:"img-fluid",attrs:{"src":__webpack_require__("gmLd"),"alt":"placeholder."}}),_vm._v(" "),_c('div',{staticClass:"mask flex-center",on:{"mouseover":function($event){_vm.hovered3 = true},"mouseleave":function($event){_vm.hovered3 = false}}},[(_vm.hovered3)?_c('h4',{staticClass:"white-text"},[_vm._v("BHKW I - Airbus")]):_vm._e()])])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":""}},[_c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"row":"","wrap":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('h4',{staticClass:"card-title",staticStyle:{"text-align":"center","font-weight":"bold","color":"#112f6b"}},[_vm._v("Weitere Leistungen")])]),_vm._v(" "),_c('v-list',_vm._l((_vm.content.leistungen),function(item){return _c('v-list-tile',{key:item.text,attrs:{"avatar":""}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("keyboard_arrow_right")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-content',{staticStyle:{"text-overflow":"ellipsis"},domProps:{"textContent":_vm._s(item.text)}})],1)],1)}))],1)],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Jmt5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KrOJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',[_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('card',{staticClass:"z-depth-1"},[_c('v-card-title',{staticClass:"layout justify-center",attrs:{"primary-title":""}},[_c('div',{staticClass:"headline"},[_vm._v("Kontaktieren Sie uns")])]),_vm._v(" "),_c('v-card-text',{staticClass:"layout justify-center"},[_c('v-list',{staticClass:"transparent",attrs:{"three-line":""}},[_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{staticClass:"blue--text text--lighten-2"},[_vm._v("phone")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("+49 4101 606880")])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{staticClass:"blue--text text--lighten-2"},[_vm._v("place")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("optiWatt GmbH")]),_vm._v(" "),_c('v-list-tile-title',[_vm._v("Heinrich-Specht-Weg 26")]),_vm._v(" "),_c('v-list-tile-title',[_vm._v("D-25421 Pinneberg, Schleswig-Holstein")])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{staticClass:"blue--text text--lighten-2"},[_vm._v("email")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("thuemler@optiwatt.de")])],1)],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "L/6f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contact_vue__ = __webpack_require__("CJgd");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_402841f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contact_vue__ = __webpack_require__("KrOJ");
function injectStyle (ssrContext) {
  __webpack_require__("v0pP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-402841f2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contact_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_402841f2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_contact_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e9231eb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("3NXS");
function injectStyle (ssrContext) {
  __webpack_require__("fY48")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e9231eb_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__("3EgV");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_css__ = __webpack_require__("Jmt5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mdbootstrap_css_mdb_css__ = __webpack_require__("r91b");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_mdbootstrap_css_mdb_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_mdbootstrap_css_mdb_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_dist_vuetify_min_css__ = __webpack_require__("7zck");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetify_dist_vuetify_min_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a, {
  theme: {
    primary: '#112f6b',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App__["a" /* default */] }
});

/***/ }),

/***/ "NNjJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Card__ = __webpack_require__("ZNfX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CardHeader__ = __webpack_require__("efVn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CardBody__ = __webpack_require__("XAfO");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        'Card': __WEBPACK_IMPORTED_MODULE_0__components_Card__["a" /* default */],
        'CardHeader': __WEBPACK_IMPORTED_MODULE_1__components_CardHeader__["a" /* default */],
        'CardBody': __WEBPACK_IMPORTED_MODULE_2__components_CardBody__["a" /* default */]
    }
});

/***/ }),

/***/ "NXbQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',[_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('card',{staticClass:"z-depth-1"},[_c('card-body',[_c('h4',{staticClass:"card-title"},[_vm._v("optiWatt GmbH")]),_vm._v(" "),_c('p',{staticClass:"card-text"},[_vm._v("\n                        Geschäftsführender Gesellschafter:"),_c('br'),_vm._v("\n                        Dipl.-Ing. Hergen Thümler"),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n                        Postanschrift:"),_c('br'),_vm._v("\n                        Heinrich-Specht-Weg 26"),_c('br'),_vm._v("\n                        25421 Pinneberg"),_c('br'),_vm._v("\n                        Deutschland"),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n                        E-Mail: thuemler@optiwatt.de"),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n                        Telefon: 04101 606880"),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n                        Handelsregister: HRB 6867"),_c('br'),_vm._v("\n                        Amtsgericht Pinneberg"),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n                        USt-IdNr.: DE253651468"),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n                        Inhaltlich Verantwortlicher gemäß § 6 MDStV:"),_c('br'),_vm._v("\n                        Hergen Thümler"),_c('br'),_vm._v("\n                        letzte Aktualisierung: 18.12.2021"),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n                        Copyright: © 2007 optiWatt GmbH, Pinneberg. All rights are reserved.Das Werk ist einschließlich aller seiner Teile, sofern keine anderen Quellen angegeben wurden, urheberrechtlich geschützt. Jede Verwendung außerhalb der engen Grenzen des Urheberrechts sind unzulässig und strafbar. Das gilt vor allem für Vervielfältigungen in irgendeiner Form (Fotokopie, Mikrokopie, oder andere Verfahren), Übersetzungen oder die Einspeicherung und Verarbeitung in elektronische Systemen. die Einrichtung eines Hyperlinks von anderen Webseiten auf eine der Seiten ist ohne vorherige schriftliche Zustimmung von optiWatt untersagt."),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n                        Haftungsausschluss: Die bereitgestellten Informationen auf dieser Website wurden sorgfältig geprüft und werden regelmäßig aktualisiert. Jedoch kann keine Haftung oder Garantie dafür übernommen werden, dass alle Angaben zu jeder Zeit vollständig, richtig und in letzter Aktualität dargestellt sind. Dies gilt insbesondere für alle Verbindungen (\"Links\") zu anderen Websites, auf die direkt oder indirekt verwiesen wird. Hinsichtlich der Links erklärt die optiWatt GmbH ausdrücklich, dass sie keinerlei Einfluss auf die Gestaltung und die Inhalte der verlinkten Seiten hat und sich diese Inhalte nicht zu eigen macht.\n                    ")])])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Q8gy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Card__ = __webpack_require__("ZNfX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CardHeader__ = __webpack_require__("efVn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CardBody__ = __webpack_require__("XAfO");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        'Card': __WEBPACK_IMPORTED_MODULE_0__components_Card__["a" /* default */],
        'CardHeader': __WEBPACK_IMPORTED_MODULE_1__components_CardHeader__["a" /* default */],
        'CardBody': __WEBPACK_IMPORTED_MODULE_2__components_CardBody__["a" /* default */]
    }
});

/***/ }),

/***/ "UCKR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/klinikum.062a33e.jpg";

/***/ }),

/***/ "Vbwo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',[_c('v-flex',{staticStyle:{"padding":"10px"},attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c('card',{staticClass:"z-depth-1"},[_c('card-body',[_c('h2',[_vm._v("Datenschutzerklärung")]),_vm._v("\n                    Personenbezogene Daten (nachfolgend zumeist nur „Daten“ genannt) werden von uns nur im Rahmen der Erforderlichkeit sowie zum Zwecke der Bereitstellung eines funktionsfähigen und nutzerfreundlichen Internetauftritts, inklusive seiner Inhalte und der dort angebotenen Leistungen, verarbeitet.\n                    Gemäß Art. 4 Ziffer 1. der Verordnung (EU) 2016/679, also der Datenschutz-Grundverordnung (nachfolgend nur „DSGVO“ genannt), gilt als „Verarbeitung“ jeder mit oder ohne Hilfe automatisierter Verfahren ausgeführter Vorgang oder jede solche Vorgangsreihe im Zusammenhang mit personenbezogenen Daten, wie das Erheben, das Erfassen, die Organisation, das Ordnen, die Speicherung, die Anpassung oder Veränderung, das Auslesen, das Abfragen, die Verwendung, die Offenlegung durch Übermittlung, Verbreitung oder eine andere Form der Bereitstellung, den Abgleich oder die Verknüpfung, die Einschränkung, das Löschen oder die Vernichtung.\n                    Mit der nachfolgenden Datenschutzerklärung informieren wir Sie insbesondere über Art, Umfang, Zweck, Dauer und Rechtsgrundlage der Verarbeitung personenbezogener Daten, soweit wir entweder allein oder gemeinsam mit anderen über die Zwecke und Mittel der Verarbeitung entscheiden. Zudem informieren wir Sie nachfolgend über die von uns zu Optimierungszwecken sowie zur Steigerung der Nutzungsqualität eingesetzten Fremdkomponenten, soweit hierdurch Dritte Daten in wiederum eigener Verantwortung verarbeiten.\n                    "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n                    Unsere Datenschutzerklärung ist wie folgt gegliedert:\n                    "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n                    I. Informationen über uns als Verantwortliche"),_c('br'),_vm._v("\n                    II. Rechte der Nutzer und Betroffenen"),_c('br'),_vm._v("\n                    III. Informationen zur Datenverarbeitung"),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("I. Informationen über uns als Verantwortliche"),_c('br')]),_vm._v("\n                    Verantwortlicher Anbieter dieses Internetauftritts im datenschutzrechtlichen Sinne ist:"),_c('br'),_vm._v("\n                    optiWatt GmbH"),_c('br'),_vm._v("\n                    Heinrich-Specht-Weg 26"),_c('br'),_vm._v("\n                    25421 Pinneberg"),_c('br'),_vm._v("\n                    Deutschland"),_c('br'),_vm._v("\n                    Telefon: 04101 606880"),_c('br'),_vm._v("\n                    Telefax: 04101 606881"),_c('br'),_vm._v("\n                    E-Mail: info@optiwatt.de"),_c('br'),_vm._v("\n                    Datenschutzbeauftragter  ist:"),_c('br'),_vm._v("\n                    Hergen Thümler"),_c('br'),_vm._v("\n                    Adresse und Kontaktdaten siehe oben "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("II. Rechte der Nutzer und Betroffenen")]),_vm._v("\n                    Mit Blick auf die nachfolgend noch näher beschriebene Datenverarbeitung haben die Nutzer und Betroffenen das Recht\n                    auf Bestätigung, ob sie betreffende Daten verarbeitet werden, auf Auskunft über die verarbeiteten Daten, auf weitere Informationen über die Datenverarbeitung sowie auf Kopien der Daten (vgl. auch Art. 15 DSGVO);\n                    auf Berichtigung oder Vervollständigung unrichtiger bzw. unvollständiger Daten (vgl. auch Art. 16 DSGVO);\n                    auf unverzügliche Löschung der sie betreffenden Daten (vgl. auch Art. 17 DSGVO), oder, alternativ, soweit eine weitere Verarbeitung gemäß Art. 17 Abs. 3 DSGVO erforderlich ist, auf Einschränkung der Verarbeitung nach Maßgabe von Art. 18 DSGVO;\n                    auf Erhalt der sie betreffenden und von ihnen bereitgestellten Daten und auf Übermittlung dieser Daten an andere Anbieter/Verantwortliche (vgl. auch Art. 20 DSGVO);\n                    auf Beschwerde gegenüber der Aufsichtsbehörde, sofern sie der Ansicht sind, dass die sie betreffenden Daten durch den Anbieter unter Verstoß gegen datenschutzrechtliche Bestimmungen verarbeitet werden (vgl. auch Art. 77 DSGVO).\n                    Darüber hinaus ist der Anbieter dazu verpflichtet, alle Empfänger, denen gegenüber Daten durch den Anbieter offengelegt worden sind, über jedwede Berichtigung oder Löschung von Daten oder die Einschränkung der Verarbeitung, die aufgrund der Artikel 16, 17 Abs. 1, 18 DSGVO erfolgt, zu unterrichten. Diese Verpflichtung besteht jedoch nicht, soweit diese Mitteilung unmöglich oder mit einem unverhältnismäßigen Aufwand verbunden ist. Unbeschadet dessen hat der Nutzer ein Recht auf Auskunft über diese Empfänger.\n                    Ebenfalls haben die Nutzer und Betroffenen nach Art. 21 DSGVO das Recht auf Widerspruch gegen die künftige Verarbeitung der sie betreffenden Daten, sofern die Daten durch den Anbieter nach Maßgabe von Art. 6 Abs. 1 lit. f) DSGVO verarbeitet werden. Insbesondere ist ein Widerspruch gegen die Datenverarbeitung zum Zwecke der Direktwerbung statthaft.\n                    "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("III. Informationen zur Datenverarbeitung")]),_vm._v("\n                    Ihre bei Nutzung unseres Internetauftritts verarbeiteten Daten werden gelöscht oder gesperrt, sobald der Zweck der Speicherung entfällt, der Löschung der Daten keine gesetzlichen Aufbewahrungspflichten entgegenstehen und nachfolgend keine anderslautenden Angaben zu einzelnen Verarbeitungsverfahren gemacht werden.\n                    "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Cookies")]),_vm._v("\n                    Wir verwenden mit unserem Internetauftritt keine Cookies.  \n                    "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Serverdaten")]),_vm._v("\n                    Aus technischen Gründen, insbesondere zur Gewährleistung eines sicheren und stabilen Internetauftritts, werden Daten durch Ihren Internet-Browser an uns \n                    übermittelt. Mit diesen sog. Server-Logfiles werden u.a. Typ und Version Ihres Internetbrowsers, das Betriebssystem, die Website, von der aus Sie auf unseren \n                    Internetauftritt gewechselt haben (Referrer URL), die Website(s) unseres Internetauftritts, die Sie besuchen, Datum und Uhrzeit des jeweiligen Zugriffs sowie die \n                    IP-Adresse des Internetanschlusses, von dem aus die Nutzung unseres Internetauftritts erfolgt, erhoben.\n                    Diese so erhobenen Daten werden vorrübergehend gespeichert, dies jedoch nicht gemeinsam mit anderen Daten von Ihnen.\n                    Diese Speicherung erfolgt auf der Rechtsgrundlage von Art. 6 Abs. 1 lit. f) DSGVO. Unser berechtigtes Interesse liegt in der Verbesserung, Stabilität, Funktionalität\n                    und Sicherheit unseres Internetauftritts.\n                    Die Daten werden spätestens nach sieben Tage wieder gelöscht, soweit keine weitere Aufbewahrung zu Beweiszwecken erforderlich ist. Andernfalls sind die Daten \n                    bis zur endgültigen Klärung eines Vorfalls ganz oder teilweise von der Löschung ausgenommen.\n                    "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Analytik-Software")]),_vm._v("\n\n                    Wir nutzen auf unserer Seite keine Analytik-Software.\n                    "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_c('h3',[_vm._v("Kontaktanfragen / Kontaktmöglichkeit")]),_vm._v("\n                    Sofern Sie per Kontaktformular oder E-Mail mit uns in Kontakt treten, werden die dabei von Ihnen angegebenen Daten zur Bearbeitung Ihrer Anfrage genutzt. Die Angabe der Daten ist zur Bearbeitung und Beantwortung Ihre Anfrage erforderlich - ohne deren Bereitstellung können wir Ihre Anfrage nicht oder allenfalls eingeschränkt beantworten.\n                    Rechtsgrundlage für diese Verarbeitung ist Art. 6 Abs. 1 lit. b) DSGVO.\n                    Ihre Daten werden gelöscht, sofern Ihre Anfrage abschließend beantwortet worden ist und der Löschung keine gesetzlichen Aufbewahrungspflichten entgegenstehen, wie bspw. bei einer sich etwaig anschließenden Vertragsabwicklung.\n\n                ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Wkv9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "XAfO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);


var props = {
  tag: {
    type: String,
    default: "div"
  },
  className: {
    type: String
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    var dataObj = {
      class: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('card-body', props.className ? props.className : '')
    };
    return h(props.tag, dataObj, children);
  }
});

/***/ }),

/***/ "XeGw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_reference_vue__ = __webpack_require__("uXbm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60210c51_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_reference_vue__ = __webpack_require__("FZY4");
function injectStyle (ssrContext) {
  __webpack_require__("kX+s")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-60210c51"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_reference_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_60210c51_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_reference_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_container__ = __webpack_require__("vL2p");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__subpages_reference_vue__ = __webpack_require__("XeGw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__subpages_services_vue__ = __webpack_require__("qTyu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__subpages_contact_vue__ = __webpack_require__("L/6f");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__subpages_impressum_vue__ = __webpack_require__("/D0J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__subpages_datenschutz_vue__ = __webpack_require__("uT9g");









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__pages_container__["a" /* default */],
    children: [{
      path: "",
      component: __WEBPACK_IMPORTED_MODULE_4__subpages_services_vue__["a" /* default */]
    }, {
      path: "referenzen",
      component: __WEBPACK_IMPORTED_MODULE_3__subpages_reference_vue__["a" /* default */]
    }, {
      path: "kontakt",
      component: __WEBPACK_IMPORTED_MODULE_5__subpages_contact_vue__["a" /* default */]
    }, {
      path: "impressum",
      component: __WEBPACK_IMPORTED_MODULE_6__subpages_impressum_vue__["a" /* default */]
    }, {
      path: "datenschutz",
      component: __WEBPACK_IMPORTED_MODULE_7__subpages_datenschutz_vue__["a" /* default */]
    }]
  }]
}));

/***/ }),

/***/ "ZAKa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Card__ = __webpack_require__("ZNfX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CardHeader__ = __webpack_require__("efVn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CardBody__ = __webpack_require__("XAfO");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        'Card': __WEBPACK_IMPORTED_MODULE_0__components_Card__["a" /* default */],
        'CardHeader': __WEBPACK_IMPORTED_MODULE_1__components_CardHeader__["a" /* default */],
        'CardBody': __WEBPACK_IMPORTED_MODULE_2__components_CardBody__["a" /* default */]
    },
    data: function data() {
        return {
            content: {
                kraftwerktechnik: [{ text: "Analyse vorhandener Kraftwerksanlagen und Optimierung gegen Marktstrukturen" }, { text: "Entwicklung von Repowering-Konzepten" }, { text: "Machbarkeitsstudien für Neuanlagen" }],
                bhkw: [{ text: "Entwurfsplanung" }, { text: "Erstellung von Genehmigungsanträgen" }, { text: "Ausschreibungsunterlagen" }, { text: "Projektabwicklung" }],
                leistungen: [{ text: "Ausstellung von Primärenergie-Bescheinigungen (Gutachter nach FW 609)" }, { text: "Ausstellung von Bescheinigungen des Erfüllungsgrades nach GEG" }]
            },
            hovered: false,
            hovered2: false,
            hovered3: false
        };
    }
});

/***/ }),

/***/ "ZNfX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);


var props = {
  tag: {
    type: String,
    default: "div"
  },
  cascade: {
    type: Boolean,
    default: false
  },
  className: {
    type: String
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    var dataObj = {
      class: __WEBPACK_IMPORTED_MODULE_0_classnames___default()(props.cascade ? 'card-cascade' : 'card', props.className ? props.className : '')
    };
    return h(props.tag, dataObj, children);
  }
});

/***/ }),

/***/ "eSz5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "efVn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);


var props = {
  tag: {
    type: String,
    default: "div"
  },
  className: {
    type: String
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    var dataObj = {
      class: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('card-header', props.className ? props.className : '')
    };
    return h(props.tag, dataObj, children);
  }
});

/***/ }),

/***/ "fV6z":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/klosterforst.9a8c36c.jpg";

/***/ }),

/***/ "fY48":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fYy5":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/optiwatt_logo.d24b4ec.png";

/***/ }),

/***/ "gDL6":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/photovoltaic.20d7903.jpg";

/***/ }),

/***/ "gmLd":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/BHKWI.2ec17b1.jpg";

/***/ }),

/***/ "iNFv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kX+s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kzAz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);


var props = {
  tag: {
    type: String,
    default: "div"
  },
  heading: {
    type: String,
    default: ''
  },
  className: {
    type: String
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    var dataObj = {
      class: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('media-body', props.className ? props.className : '')
    };
    return h(props.tag, dataObj, children);
  }
});

/***/ }),

/***/ "ln2+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nqEi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);


var props = {
  tag: {
    type: String,
    default: "a"
  },
  src: {
    type: String,
    required: true
  },
  alt: {
    type: String
  },
  align: {
    type: String,
    default: "top"
  },
  className: {
    type: String
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    var dataObj = {
      class: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('d-flex', 'mr-3', props.align === 'center' ? 'align-self-center' : props.align === 'bottom' ? 'align-self-end' : 'align-self-start', props.className ? props.className : ''),
      attrs: {
        href: '#'
      }
    };
    var img = [h('img', {
      class: [],
      attrs: {
        src: props.src,
        alt: props.alt
      }
    })];
    return h(props.tag, dataObj, img);
  }
});

/***/ }),

/***/ "oHFg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/langenkamp.8dda2a7.jpg";

/***/ }),

/***/ "qTyu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_services_vue__ = __webpack_require__("ZAKa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_710cc5ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_services_vue__ = __webpack_require__("H7ld");
function injectStyle (ssrContext) {
  __webpack_require__("Wkv9")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-710cc5ca"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_services_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_710cc5ca_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_services_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "r91b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uT9g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_datenschutz_vue__ = __webpack_require__("Q8gy");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_345ee2da_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_datenschutz_vue__ = __webpack_require__("Vbwo");
function injectStyle (ssrContext) {
  __webpack_require__("iNFv")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-345ee2da"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_datenschutz_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_345ee2da_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_datenschutz_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "uXbm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Card__ = __webpack_require__("ZNfX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_CardHeader__ = __webpack_require__("efVn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CardBody__ = __webpack_require__("XAfO");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Media__ = __webpack_require__("zbOr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_MediaImage__ = __webpack_require__("nqEi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_MediaBody__ = __webpack_require__("kzAz");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
    components: {
        'Card': __WEBPACK_IMPORTED_MODULE_0__components_Card__["a" /* default */],
        'CardHeader': __WEBPACK_IMPORTED_MODULE_1__components_CardHeader__["a" /* default */],
        'CardBody': __WEBPACK_IMPORTED_MODULE_2__components_CardBody__["a" /* default */],
        Media: __WEBPACK_IMPORTED_MODULE_3__components_Media__["a" /* default */],
        MediaImage: __WEBPACK_IMPORTED_MODULE_4__components_MediaImage__["a" /* default */],
        MediaBody: __WEBPACK_IMPORTED_MODULE_5__components_MediaBody__["a" /* default */]
    },
    data: function data() {
        return {
            headers: [{
                text: 'Dessert (100g serving)',
                align: 'left',
                sortable: false,
                value: 'name'
            }, { text: 'Calories', value: 'calories' }],
            content: [{
                title: "AIRBUS Operations GmbH BHKW I",
                titlepicture: __webpack_require__("gmLd"),
                body: [{ head: "Aggregat", text: "Jenbacher JMS 612 GS-N.LC" }, { head: "Elektrische Leistung", text: "1.998kW" }, { head: "Thermische Auskopplung", text: "2.200kW" }, { head: "Inbetriebnahme", text: "Okt. 2010" }, { head: "Leistungsumfang optiWatt", text: "Alle Phasen HOAI (funktionale Ausschreibung) für Anlagentechnik" }]
            }, {
                title: "AIRBUS Operations GmbH BHKW II",
                titlepicture: __webpack_require__("/m10"),
                body: [{ head: "Aggregat", text: "2 Stück MWM TCG 2032 V16" }, { head: "Elektrische Leistung", text: "2 x 4.300 kW" }, { head: "Thermische Auskopplung", text: "2 x 5.000 kW" }, { head: "Wärmespeicher", text: "2 x 610 m³" }, { head: "Inbetriebnahme", text: "Feb. 2013" }, { head: "Leistungsumfang optiWatt", text: "Alle Phasen HOAI (funktionale Ausschreibung) für Anlagentechnik" }]
            }, {
                title: "Stadtwerke Glückstadt GmbH BHKW Tegelgrund",
                titlepicture: __webpack_require__("3LPk"),
                body: [{ head: "Aggregat", text: "MTU ME 3042 L3" }, { head: "Elektrische Leistung", text: "357 kW" }, { head: "Thermische Auskopplung", text: "519 kW" }, { head: "Inbetriebnahme", text: "Sep. 2009" }, { head: "Wärmespeicher", text: "80 m³" }]
            }, {
                title: "Stadtentwässerung Itzehoe BHKW Klärwerk",
                titlepicture: __webpack_require__("323/"),
                body: [{ head: "Aggregat", text: "MTU MB3066L4" }, { head: "Elektrische Leistung", text: "192 kW" }, { head: "Thermische Auskopplung", text: "214 kW" }, { head: "Inbetriebnahme", text: "Nov. 2011" }, { head: "Wärmespeicher", text: "50m³" }, { head: "Leistungsumfang optiWatt", text: "Alle Phasen HOAI (funktionale Ausschreibung) für Anlagentechnik" }]
            }, {
                title: "Stadtwerke Itzehoe GmbH BHKW Klinikum",
                titlepicture: __webpack_require__("UCKR"),
                body: [{ head: "Aggregat", text: "MTU 20V4000 L62" }, { head: "Elektrische Leistung", text: "1.944 kW" }, { head: "Thermische Auskopplung", text: "2.324 kW" }, { head: "Wärmespeicher", text: "300 m³ horizontal" }, { head: "Inbetriebnahme", text: "Aug. 2012" }, { head: "Leistungsumfang optiWatt", text: "Alle Phasen HOAI (funktionale Ausschreibung) für Anlagentechnik" }]
            }, {
                title: "Stadtwerke Itzehoe GmbH BHKW Klosterforst",
                titlepicture: __webpack_require__("fV6z"),
                body: [{ head: "Aggregat", text: "MTU 20V4000 L62" }, { head: "Elektrische Leistung", text: "1.944 kW" }, { head: "Thermische Auskopplung", text: "2.324 kW" }, { head: "Wärmespeicher", text: "2 x 160m³ (horizontal)" }, { head: "Inbetriebnahme", text: "Feb. 2010" }, { head: "Leistungsumfang optiWatt", text: "Alle Phasen HOAI (funktionale Ausschreibung) für Anlagentechnik" }]
            }, {
                title: "Stadtwerke Wedel GmbH BHKW Heinestraße",
                titlepicture: __webpack_require__("CDGV"),
                body: [{ head: "Aggregat", text: "MTU 12V400 GS E3042L9" }, { head: "Elektrische Leistung", text: "357 kW" }, { head: "Thermische Auskopplung", text: "545 kW" }, { head: "Inbetriebnahme", text: "2019" }, { head: "Wärmespeicher im Gebäude", text: "2 x 30m³" }, { head: "Leistungsumfang optiWatt", text: "Alle Phasen HOAI (funktionale Ausschreibung) für Anlagentechnik" }]
            }, {
                title: "Stadtwerke Wedel GmbH BHKW Langenkamp",
                titlepicture: __webpack_require__("oHFg"),
                body: [{ head: "Aggregat", text: "MTU 16V4000 GS" }, { head: "Elektrische Leistung", text: "1999 kW" }, { head: "Thermische Auskopplung", text: "2050 kW" }, { head: "Inbetriebnahme", text: "2018" }, { head: "Wärmespeicher", text: "2 x 160m³" }, { head: "Leistungsumfang optiWatt", text: "Alle Phasen HOAI (funktionale Ausschreibung) für Anlagentechnik" }]
            }, {
                title: "Stadtwerke Wedel GmbH BHKW Hafen",
                titlepicture: __webpack_require__("7Sn+"),
                body: [{ head: "Elektrische Leistung", text: "ca. 2 MW" }, { head: "Thermische Auskopplung", text: "ca. 2,5 MW" }, { head: "Kesselleistung", text: "ca. 1,8 MW" }, { head: "PtH Elektrokessel", text: "ca. 1,0 MW" }, { head: "Wärmespeicher", text: "> 300 m³" }, { head: "Ausschreibung und Baubeginn", text: "2022" }, { head: "Leistungsumfang optiWatt", text: "Alle Phasen HOAI (funktionale Ausschreibung) für Anlagentechnik" }]
            }]
        };
    }
});

/***/ }),

/***/ "ucym":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('div',[_c('v-flex',[_c('div',{staticClass:"text-center",staticStyle:{"margin-top":"30px"}},[_c('img',{staticStyle:{"max-width":"150px"},attrs:{"src":__webpack_require__("fYy5"),"alt":"placeholder."}})])]),_vm._v(" "),_c('v-flex',[_c('div',{staticClass:"rectangle"})]),_vm._v(" "),_c('v-tabs',{attrs:{"fixed-tabs":"","slider-color":"primary"}},[_c('v-tab',{attrs:{"to":"/"}},[_vm._v("\n                Leistungen\n            ")]),_vm._v(" "),_c('v-tab',{attrs:{"to":"referenzen"}},[_vm._v("\n                Referenzen\n            ")]),_vm._v(" "),_c('v-tab',{attrs:{"to":"kontakt"}},[_vm._v("\n                Kontakt\n            ")]),_vm._v(" "),_c('v-tab',{attrs:{"to":"impressum"}},[_vm._v("\n                Impressum\n            ")]),_vm._v(" "),_c('v-tab',{attrs:{"to":"datenschutz"}},[_vm._v("\n                Datenschutz\n            ")])],1),_vm._v(" "),_c('router-view')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "v0pP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vL2p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_container_vue__ = __webpack_require__("zBRM");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e5df4b5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_container_vue__ = __webpack_require__("ucym");
function injectStyle (ssrContext) {
  __webpack_require__("eSz5")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e5df4b5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_container_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e5df4b5_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_container_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),

/***/ "zBRM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    components: {},
    data: function data() {
        return {};
    }
});

/***/ }),

/***/ "zbOr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export props */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames__ = __webpack_require__("HW6M");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_classnames__);


var props = {
  tag: {
    type: String,
    default: "div"
  },
  className: {
    type: String
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,
  props: props,
  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    var dataObj = {
      class: __WEBPACK_IMPORTED_MODULE_0_classnames___default()('media', props.className ? props.className : '')
    };
    return h(props.tag, dataObj, children);
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.5e1458947f182c5b6dca.js